import PropTypes from 'prop-types';
import { widgetConfigsPropTypes } from './widgetConfigs.proptypes';

export const themePropTypes = PropTypes.shape({
  configs: widgetConfigsPropTypes,
});
